import React from 'react';
import type { GlobalRuleType } from 'Common/enums';
import { Button } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { useDispatch } from 'react-redux';
import { setGroup, setGroupView } from 'Store';

type EditRuleButtonProps = {
    id: string;
    ruleType: GlobalRuleType;
    selectedRowId: string;
    nonTemplated?: boolean;
    selectViewOption?: string;
};

const EditRuleButton = ({
    id,
    selectedRowId,
    nonTemplated = false,
    ruleType,
    selectViewOption
}: EditRuleButtonProps) => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const editRule = () => {
        dispatch(setGroup(''));
        dispatch(setGroupView(selectViewOption));

        switch (ruleType) {
            case 'Advanced Rule':
                history.push(`${location.pathname}/adhoc/edit-advanced-rule/${id}?selectedRowId=${selectedRowId}`);
                break;

            default:
                if (nonTemplated) {
                    history.push(`${location.pathname}/adhoc/edit-rule/${id}?selectedRowId=${selectedRowId}`);
                } else {
                    history.push(`${location.pathname}/edit-rule/${id}?selectedRowId=${selectedRowId}`);
                }
                break;
        }
    };

    return (
        <Button
            dataTestId='edit-rule-button'
            variant='tertiary'
            onClick={handleOnClickEvent(editRule)}
            onKeyDown={handleKeyEvent(editRule)}
        >
            {t('Edit Rule')}
        </Button>
    );
};

export default React.memo(EditRuleButton);
